import { useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS, apiRequest } from '@/lib/api';

export interface Project {
  id: number;
  name: string;
  initials: string;
  type: number;
  status: number;
}

export function useProjects() {
  return useQuery({
    queryKey: ['projects'],
    queryFn: async () => {
      const response = await apiRequest(API_ENDPOINTS.PROJECTS.LIST);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ 
          detail: 'Failed to fetch projects' 
        }));
        throw new Error(errorData.detail || 'Failed to fetch projects');
      }

      const data = await response.json();
      return (data.results || data) as Project[];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}



